import { useState, useEffect } from 'react';
import { fetchCardSuiteDetails } from '../api/fetchCardSuiteDetails';

export const useCardSuiteDetails = (cardSuiteUUID, isAdminView) => {
  const [cardSuiteDetails, setCardSuiteDetails] = useState(null);

  useEffect(() => {
    fetchCardSuiteDetails(cardSuiteUUID, isAdminView).then(setCardSuiteDetails);
  }, [cardSuiteUUID, isAdminView]);

  return cardSuiteDetails;
};
